import { Box, Drawer, Grid, IconButton, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { API } from '../../utils/Api';
import { setData } from '../../store/Cart/cartSlice';
import toast from 'react-hot-toast';
import ProductDrawer from '../ProductDrawer';
import Images from '../../utils/Images';
import { AddCircleOutlineOutlined } from '@mui/icons-material';

const PromotedProducts = () => {
    const token = localStorage.getItem('token');
    const [products, setProducts] = useState([]);
    const outlet = localStorage.getItem("selectedStoreData");
    const deliveryType = localStorage.getItem("selectedOrderType");
    const outletObject = JSON.parse(outlet);
    const outletId = outletObject?._id;
    const dispatch = useDispatch();
    const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));
    const [quantity, setQuantity] = useState(1);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isFavorited, setIsFavorited] = useState(false);
    const [selectedAddons, setSelectedAddons] = useState({});
    const [wishlistData, setWishlistData] = useState([]);
    const ordersType = localStorage.getItem("selectedOrderType");

    const handleCloseModal = () => {
        setSelectedProduct(null);
        setQuantity(1);
        setSelectedAddons({});
    };

    const getRandomProducts = async () => {
        try {
            const response = await axios.get(`${API.BASE_URL}promoting-products?outletId=${outletData._id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setProducts(response.data.data.products);
            console.log('Promoted products', response.data.data.products);

        } catch (error) {
            console.log('Combo Suggested Products Error API Response', error?.response);
        }
    };

    useEffect(() => {
        getRandomProducts();
        setOutletData(JSON.parse(localStorage.getItem('selectedStoreData')));
    }, []);

    const fetchUserCartData = async () => {
        try {
            const response = await axios.get(`${API.BASE_URL_2}cart/userCart/new/${outletData._id}/${deliveryType}?source=WEBSITE`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            dispatch(setData(response?.data));
            // console.log('Cart Screen Data', response?.data);
        } catch (error) {
            dispatch(setData([]));
            // console.log('Cart Screen Error', error?.response?.data);
        }
    };

    const handleAddToCart = async () => {
        try {
            const addonsArray = Object.keys(selectedAddons).map((addonId) => ({
                _id: addonId,
                selectedValue: selectedAddons[addonId].value,
                addonValueId: selectedAddons[addonId]._id,
            }));
            const cartItem = {
                ordersType: deliveryType,
                outlet: outletId,
                cartItems: [
                    {
                        product: selectedProduct._id,
                        quantity: quantity,
                        sourceTye: "WEBSITE",
                        addons: addonsArray.length > 0 ? addonsArray : undefined,
                    }
                ],
            };
            const response = await axios.post(`${API.BASE_URL_2}cart/new`, cartItem, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            handleCloseModal();
            fetchUserCartData();
            toast.success('Product added to cart!!!');
            console.log(response.data);
        } catch (error) {
            console.error(error);
            console.log('handleAddToCart', error?.response?.data?.error);
            toast.error(error?.response?.data?.error);
        }
    };

    const handleAddonSelect = (addonId, addonValue, isMultipleSelect = false) => {
        setSelectedAddons((prevSelectedAddons) => {
            if (isMultipleSelect) {
                const currentSelections = Array.isArray(prevSelectedAddons[addonId]) ? prevSelectedAddons[addonId] : [];
                const isAlreadySelected = currentSelections.some(
                    (selected) => selected._id === addonValue._id
                );

                const updatedSelections = isAlreadySelected
                    ? currentSelections.filter((selected) => selected._id !== addonValue._id) : [...currentSelections, addonValue];

                console.log('updatedSelections', updatedSelections);

                return {
                    ...prevSelectedAddons,
                    [addonId]: updatedSelections,
                };
            } else {
                const isSelected = prevSelectedAddons[addonId]?._id === addonValue?._id;
                const isDefault = addonValue?.isDefault;

                if (isSelected && !isDefault) {
                    const updatedAddons = { ...prevSelectedAddons };
                    delete updatedAddons[addonId];
                    return updatedAddons;
                }

                return {
                    ...prevSelectedAddons,
                    [addonId]: addonValue,
                };
            }
        });
    };

    const getRandomRating = () => {
        return (Math.random() * (4.2 - 3.7) + 3.7).toFixed(1);
    };

    const isProductInWishlist = (productId) => {
        return wishlistData.includes(productId);
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
    };

    const [totalPrice, setTotalPrice] = useState(selectedProduct?.newOfferPrice || 0);
    const [totalMrpPrice, setTotalMrpPrice] = useState(selectedProduct?.newMrp || 0);
    const [offerPercentage, setOfferPercentage] = useState(0);

    useEffect(() => {
        const calculateTotalPrice = () => {
            let price = selectedProduct?.newOfferPrice || 0;
            let mrp = selectedProduct?.newMrp || 0;
            Object.values(selectedAddons).forEach(addon => {
                if (Array.isArray(addon)) {
                    addon.forEach(val => {
                        price += val?.offerPrice ?? val?.price ?? 0;
                        mrp += val?.mrp ?? val?.price ?? 0;
                    });
                } else if (addon && typeof addon === 'object') {
                    price += addon?.offerPrice ?? addon?.price ?? 0;
                    mrp += addon?.mrp ?? addon?.price ?? 0;
                }
            });
            setTotalPrice(price);
            setTotalMrpPrice(mrp);
        };
        calculateTotalPrice();
    }, [selectedAddons, selectedProduct]);

    useEffect(() => {
        if (totalMrpPrice > 0 && totalPrice < totalMrpPrice) {
            const discount = ((totalMrpPrice - totalPrice) / totalMrpPrice) * 100;
            setOfferPercentage(discount);
        } else {
            setOfferPercentage(0);
        }
    }, [totalPrice, totalMrpPrice]);

    const handleIncreaseQuantity = () => {
        setQuantity((prevQuantity) => prevQuantity + 1);
    };

    const handleDecreaseQuantity = () => {
        if (quantity > 1) {
            setQuantity((prevQuantity) => prevQuantity - 1);
        }
    };

    const handleFavoriteClick = async () => {
        try {
            if (isProductInWishlist(selectedProduct._id)) {
                const response = await axios.post(
                    `${API.BASE_URL}wishlist/remove`,
                    { productId: selectedProduct?._id },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setIsFavorited(false);
                toast.success('Product removed from favorites!!!');
                console.log("Wishlist Remove Success", response.data);
            } else {
                const response = await axios.post(
                    `${API.BASE_URL}wishlist/add`,
                    { productId: selectedProduct._id },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setIsFavorited(true);
                toast.success('Product added to favorites!!!');
                console.log("Wishlist Add Success", response.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Box className="promotedProducts">
            <Typography className="title">Add More And Save Big 🎉</Typography>
            <Box className="promotedProductsContainer">
                {products.map((product, index) => (
                    <Box
                        key={product?._id}
                        onClick={() => !product?.isExhausted && handleProductClick(product)}
                        className="xpCard"
                        sx={{ backgroundColor: "transparent" }}
                    >
                        <Box className="xpCardMedia">
                            <Box className="xpImgWrap">
                                <img
                                    className="xpCardImg"
                                    src={product?.coverImageUrl || Images.subscriptionBanner}
                                    alt={product?.name || "product"}
                                />
                            </Box>

                            <Box className="xpVegBadge">
                                <span className="xpVegDot" />
                            </Box>
                            
                            <Box className="xpVegBadge">
                                {product?.foodType === 'VEG/VEGAN' ? (
                                    <Stack direction={'row'}>
                                        <img className='xpVegDot' src={Images.veg} alt='veg' />
                                        <img style={{ height: '17px', marginRight: '4px', marginLeft: '0px' }} className='xpVegDot' src={Images.vegan} alt='vegan' />
                                    </Stack>
                                ) : (
                                    <img className='xpVegDot' src={product?.foodType === 'VEG' ? Images.veg : (product?.foodType === 'VEGAN' ? Images.vegan : Images.nonVeg)} alt={product?.foodType === 'VEG' ? 'veg' : (product?.foodType === 'VEGAN' ? 'vegan' : 'non-veg')} />
                                )}
                            </Box>

                            <Box
                                className="xpPlusBtn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!product?.isExhausted) handleProductClick(product);
                                }}
                            >
                                +
                            </Box>
                        </Box>
                        <Box className="xpCardBody">
                            <Typography className="xpTitle">
                                {product?.name}
                            </Typography>
                            <Typography className="xpPrice">
                                ₹{Number(product?.offerPrice || 200).toFixed(0)}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
            <ProductDrawer
                open={!!selectedProduct}
                onClose={handleCloseModal}
                selectedProduct={selectedProduct}
                handleAddToCart={handleAddToCart}
                isFavorited={isFavorited}
                handleFavoriteClick={handleFavoriteClick}
                quantity={quantity}
                handleIncreaseQuantity={handleIncreaseQuantity}
                handleDecreaseQuantity={handleDecreaseQuantity}
                selectedAddons={selectedAddons}
                handleAddonSelect={handleAddonSelect}
                totalPrice={totalPrice}
                totalMrpPrice={totalMrpPrice}
                offerPercentage={offerPercentage}
            />
        </Box>
        // ) : null
    )
}

export default PromotedProducts;
